import ListLibraryNode from "./ListLibraryNode.mjs";
import ModalEditLibraryRoot from "../modals/ModalEditLibraryRoot.mjs";
import React from "react";

const ListLibraryRoot = class extends ListLibraryNode {
	/**
	 * @param {LibraryNodeListProps} props
	 */
	constructor(props) {
		super(props);
		this.state.dontDelete = true;
	}

	editor() {
		if ( ! this.state.onEdit ) return '';
		if ( this.state.onEdit === true) {
			return (
				<ModalEditLibraryRoot
					data={ this.state.data }
					cancel={ ()=>{ this.setState({ onEdit: false }) }}
					save={ d => {
						this.setState({ onEdit: false }, ()=>{
							this.props.onChange(d);
						});
					} }
				/>
			);
		}
		return super.editor();
	}
}

export default ListLibraryRoot;
